import React, { FC } from 'react';
import Svg from 'svg-inline-react';
import { Image } from '@src/components/Image';
import { STATIC_MEDIA_DOMAIN } from '@src/constants';
import FrStarSvg from '@src/svgs/fr-star.svg';
import './styles.scss';

export const Banner: FC = () => {
  return (
    <div className="activity-feed-banner">
      <Image
        alt=""
        className="activity-feed-banner__image"
        src={`${STATIC_MEDIA_DOMAIN}/images/activity-feed-banner.png`}
      />
      <Svg className="activity-feed-banner__star" src={FrStarSvg} />
      <div className="activity-feed-banner__info">
        <h4 className="activity-feed-banner__title">
          Who’s <span>viewed</span> your job offers.
        </h4>
        <ul className="activity-feed-banner__list">
          <li>Find out who has viewed your job offers.</li>
          <li>Discover which viewers are open to headhunting.</li>
          <li>Track who has started an application.</li>
        </ul>
      </div>
    </div>
  );
};
